import { useCallback } from 'react'
import { buildMapFitBounds } from 'components/common/map/bounds'
import { isValidLatLng } from 'components/common/map/constants'

const DEFAULT_PADDING = { top: 30, right: 30, bottom: 30, left: 30 }

export const useFitBoundsLogic = ({ map, mapsLib, data, latitude, longitude, radius }) => {
  const fitBounds = useCallback(
    paddingOverride => {
      if (!map || !mapsLib) return
      const hasData = Array.isArray(data) && data.length > 0
      const centerValid = isValidLatLng(latitude, longitude)
      if (!centerValid && !hasData) return

      const result = buildMapFitBounds({ mapsLib, data, latitude, longitude, radius })
      if (!result) return
      const { bounds, hasMarkers } = result

      // Empty bounds → fitBounds would pan to (0,0) / world view. Bail.
      if (hasMarkers || (radius && centerValid)) {
        map.fitBounds(bounds, paddingOverride || DEFAULT_PADDING)
      } else if (centerValid) {
        map.setCenter({ lat: latitude, lng: longitude })
        map.setZoom(17)
      }
    },
    [map, mapsLib, data, latitude, longitude, radius]
  )

  return { fitBounds }
}
